import PropTypes from 'prop-types'
import { memo, useMemo, useRef } from 'react'
import getUniqueIdString from 'lib/util/uniq'
import styles from './Logo.module.scss'
import useAnimationIcon from './hooks/useAnimationIcon'
import SVGIcon from './svg/SVGIcon'

/**
 * The `LogoStandard`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function LogoStandard (props) {
  const { className, isActive, style: inputStyle, ...attributes } = props
  const ref = useRef()
  const uid = useRef(getUniqueIdString('logo-'))
  const outputClassName = useMemo(
    () => [styles.logo, styles.logoStandard, className].join(' '),
    [className]
  )
  const style = useMemo(
    () => ({
      ...inputStyle,
      '--logo-gradient': `url(#${uid.current})`
    }),
    []
  )

  useAnimationIcon(ref, isActive)

  return (
    <SVGIcon
      ref={ref}
      className={outputClassName}
      style={style}
      uid={uid.current}
      {...attributes}
    />
  )
}

/** @type {object} */
LogoStandard.propTypes = {
  className: PropTypes.string,
  isActive: PropTypes.bool,
  style: PropTypes.shape()
}

/** @type {object} */
LogoStandard.defaultProps = {
  className: '',
  isActive: true,
  style: {}
}

// Memoize
export default memo(LogoStandard)
